(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.hasAttribute('data-product-card-navigation-ready')) {
    document.documentElement.setAttribute('data-product-card-navigation-ready', '');
    document.addEventListener('click', (event) => {
      const card = event.target.closest('[data-product-card-navigation]');
      if (!card || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || window.Shopify?.designMode) return;
      if (event.target.closest('a, button, input, select, textarea, label, summary, details, [role="button"], [contenteditable="true"]')) return;
      window.location.assign(card.dataset.productCardNavigation);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
